import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Cookie } from "@phosphor-icons/react";

const KEY = "ldz-cookies";

export const CookieBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = (value) => { localStorage.setItem(KEY, value); setVisible(false); };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[90] bg-ink text-sand border-t border-sand/15 px-6 py-5 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row md:items-center gap-4 justify-between">
        <p className="text-xs md:text-sm text-sand/75 font-light leading-relaxed flex items-start gap-3 max-w-3xl">
          <Cookie size={20} className="shrink-0 text-[#D5C0A1] mt-0.5" />
          {t("cookies.text")}
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <Link
            data-testid="cookie-more"
            to="/legal/cookies"
            className="text-[11px] uppercase tracking-[0.15em] text-sand/60 hover:text-[#D5C0A1] transition-colors"
          >
            {t("cookies.more")}
          </Link>
          <button
            data-testid="cookie-reject"
            onClick={() => accept("reject")}
            className="px-6 py-3 border border-sand/30 text-sand text-[11px] uppercase tracking-[0.15em] hover:border-sand transition-colors"
          >
            {t("cookies.reject")}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => accept("accept")}
            className="px-6 py-3 bg-[#D5C0A1] text-ink text-[11px] uppercase tracking-[0.15em] hover:bg-sand transition-colors"
          >
            {t("cookies.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
